import workflowApi from '@/api/workflow/workflow'
import messageUtil from '@/utils/messageUtil'

export const eLeaveMethod = {
  methods: {
    setApproverByLastFormMetas (form, businessCode) {
      workflowApi.getPersonalLastFormMetas(resp => {
        let formMetas = resp.data
        if (formMetas && formMetas.length) {
          let approverMeta = formMetas.find(e =>
            // e.workItemId == null && e.formMetaKey === 'approver'
            e.formMetaKey === 'approverName'
          )
          if (approverMeta && approverMeta.formMetaValue) {
            form.approver = approverMeta.formMetaValue
          }
        }
      }, businessCode)
    },

    downloadFile (formCode) {
      this.downloadLoading = true
      workflowApi.downloadAppliedPdfFromOss(formCode, resp => {
        if (resp.status === 201 || resp.status === 200) {
          const url = window.URL.createObjectURL(new Blob([resp.data]))
          const link = document.createElement('a')
          link.href = url
          // let disposition = resp.headers['content-disposition']
          // let filename = disposition.slice(disposition.lastIndexOf('=') + 1).replace(/"/g, '')
          link.setAttribute('download', formCode + '.pdf')
          link.click()
          window.URL.revokeObjectURL(url)
        } else {
          messageUtil.httpStatusHandler(resp, this)
        }
        this.downloadLoading = false
      })
    },

    showDownloadButton (formCode) {
      return (formCode && !formCode.startsWith('000'))
    },

    downloadELeaveAttachments (formCode) {
      workflowApi.downloadAttachmentsByFormCode(formCode, resp => {
        if (resp.status === 201 || resp.status === 200) {
          const url = window.URL.createObjectURL(new Blob([resp.data]))
          const link = document.createElement('a')
          link.href = url
          // let disposition = resp.headers['content-disposition']
          // let filename = disposition.slice(disposition.lastIndexOf('=') + 1).replace(/"/g, '')
          link.setAttribute('download', 'attachment.zip')
          link.click()
          window.URL.revokeObjectURL(url)
        } else {
          messageUtil.httpStatusHandler(resp, this)
        }
      })
    }
  }
}
